import module from 'fanconsultores/module.js'
import { isObject } from 'lodash'

module.run(($rootScope, $localStorage, $api, $jwt) => {
  $rootScope.$watch(() => $localStorage.token, (token) => {
    $api.destroyCache()

    if (token) {
      $rootScope.$broadcast('$sessionAuth', $jwt.decode(token))
    } else {
      $rootScope.$broadcast('$sessionUnauth')
    }
  })

  $rootScope.$on('$stateChangeError', (event, toState, toParams, fromState, fromParams, error) => {
    console.warn('$stateChangeError:', error, {state: toState.name, params: toParams})

    const status = isObject(error) && 'status' in error && Number(error.status)

    switch (status) {
      case 401:
        let params = {
          error: error,
          from: {state: fromState.name, params: fromParams},
          to: {state: toState.name, params: toParams},
        }

        $rootScope.$broadcast('$app:unauthorized', params)
        break

      case 403:
        alert('Acceso no permitido.')
        break

      default:
        $rootScope.$broadcast('$app:error', {error: error})
    }

    event.preventDefault()
  })
})



// WEBPACK FOOTER //
// ./src/fanconsultores/run.js